{
  "projectId": "what-was-it-gc-fb-56459",
  "appId": "1:496511501544:web:27e46872c9e0515989f55d",
  "apiKey": "AIzaSyB6Uke8QskA-oHV4IATCy0k3KNXhUzMf8A",
  "authDomain": "what-was-it-gc-fb-56459.firebaseapp.com",
  "firestoreDatabaseId": "ai-studio-9aee938d-047b-4b8e-92f4-a3509b03abbb",
  "storageBucket": "what-was-it-gc-fb-56459.firebasestorage.app",
  "messagingSenderId": "496511501544",
  "measurementId": ""
}